import React from 'react';
import I18n from 'lib/i18n/i18n';

import UserActions from 'lib/userActions';
import PopupListing from '../popups/popupListing';
import { NotificationBanner} from "@worthy-npm/clarity";

class Stages extends React.Component {
    showListingStagesPopup(idx, stage) {
        const popupContent = I18n.getVar('listingPage::stepsPopups');
        const { item } = this.props;

        UserActions.listingPage(`Stage "${ stage }" has been clicked`, item.id, this.props.version);

        return PopupListing.initPopup({
            title: popupContent[idx]['title'],
            content:
                popupContent[idx]['text']
                    .replace(/%valuable%/g, item.item_type === 'loose diamond' ? 'diamond' : item.item_type)
                    .replace(/%preposition%/, 'it'), // TODO: someday there will be Items in plural
            onOpen: () => {
                UserActions.listingPage(`"${stage}" popup has been opened`, item.id, this.props.version);
            },
            onClose: () => {
                UserActions.listingPage(`"${stage}" popup has been closed`, item.id, this.props.version);
            }
        });
    }

    render() {
        const stages = I18n.getVar('listingPage::steps');
        const { step, simple } = this.props;
        const header_el = document.querySelector('header .header');
        const sticky_header_height = header_el && header_el.getClientRects() && header_el.getClientRects()[0] && header_el.getClientRects()[0]['height'] ? header_el.getClientRects()[0]['height'] : 0;

        return <div className={`stages ${ simple ? 'stages-type-simple': '' }`}>
            { simple? null : <h2 className='listing-title h2'>{ I18n.getString('listingPage::whatToExpectTitle') }</h2> }
            <div className='listing-responsibilities'>
                <span className='listing-responsibility you'>
                    <i className="by-icon you"/>
                    { I18n.getString('listingPage::you') }
                </span>
                <span className='listing-responsibility worthy'>
                    <i className="by-icon worthy"/>
                    { I18n.getString('listingPage::worthy') }
                </span>
            </div>
            <ol className='listing-stages'>
                {
                    stages.map((stage, idx) => {
                        const byWorthyClass = [0, 1, 7, 8, 9].includes(idx) ? '' : 'by-worthy '
                        const finishedClass =  idx < step ? 'finished ' : '';
                        return <li className={
                            `listing-stage 
                                ${ finishedClass }
                                ${idx === step ? 'current ' : ''}
                                ${ byWorthyClass }`
                        }  key={idx}>
                            <div
                                className={`stage-wrapper ${byWorthyClass}${finishedClass}`}
                                onClick={
                                    () => {
                                        if (idx === 0) { return } // All but the first step
                                        this.showListingStagesPopup(idx, stage);
                                    }
                                }
                            >
                                <i className="stage-icon"/>
                                <span className={`stage-caption`}>{ stage }</span>
                            </div>
                            {
                                idx === step ? <span  style={{marginLeft: '25px' }} className={'arrow-label'}>{I18n.getString('listingPage::stepsLabels::current')}</span> : null
                            }
                        </li>
                    })
                }
            </ol>
            { simple ? null : <NotificationBanner offsetTop={sticky_header_height} stickToParent={true} text={ I18n.getString('listingPage::freeShipBack')  } onEnterViewport={ this.props.showBannerCb } onLeaveViewport={ this.props.showBannerCb }/> }
        </div>
    }
}


export default Stages;
